import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Check, Gift, Baby, Users } from 'lucide-react';
export function WhatsIncluded() {
  const tomosNinos = [{
    name: 'Tomo 1 — Mis primeras teclas: Conocé el piano jugando',
    value: '7.990'
  }, {
    name: 'Tomo 2 — Mis primeras melodías: Notas y canciones simples',
    value: '7.990'
  }, {
    name: 'Tomo 3 — Ritmo y diversión: Coordinación con las dos manos',
    value: '6.990'
  }, {
    name: 'Tomo 4 — ¡Ya toco canciones!: Repertorio completo para niños',
    value: '6.990'
  }];
  const tomosAdolescentes = [{
    name: 'Tomo 1 — Punto de partida: El teclado desde cero',
    value: '7.990'
  }, {
    name: 'Tomo 2 — Primeras canciones reales: Melodías que te gustan',
    value: '7.990'
  }, {
    name: 'Tomo 3 — Ritmo y técnica: Coordinación y fluidez',
    value: '6.990'
  }, {
    name: 'Tomo 4 — Nivel completo: Repertorio moderno y variado',
    value: '6.990'
  }];
  const bonos = [{
    name: 'Guía de práctica diaria (15 min/día)',
    value: '3.390'
  }, {
    name: 'Planillas de seguimiento y progreso',
    value: '2.490'
  }, {
    name: 'Ejercicios de calentamiento express',
    value: '2.180'
  }];
  const renderTomo = (tomo: {
    name: string;
    value: string;
  }, index: number) => <FadeIn key={index} delay={index * 0.06} direction="up" data-id="element-262">
      <div className="flex items-center justify-between gap-4 bg-navy-lighter p-4 rounded-xl border border-white/5" data-id="element-263">
        <div className="flex items-center gap-3" data-id="element-264">
          <div className="w-7 h-7 rounded-full bg-gold flex items-center justify-center flex-shrink-0" data-id="element-265">
            <Check className="w-4 h-4 text-navy" strokeWidth={3} data-id="element-266" />
          </div>
          <span className="text-base md:text-lg font-medium text-beige" data-id="element-267">
            {tomo.name}
          </span>
        </div>
        <span className="text-sm text-beige/40 line-through flex-shrink-0" data-id="element-268">
          AR$ {tomo.value}
        </span>
      </div>
    </FadeIn>;
  return <section className="py-20 bg-navy-light relative overflow-hidden" data-id="element-269">
      <div className="absolute top-20 right-0 w-96 h-96 bg-gold/8 rounded-full blur-3xl pointer-events-none" data-id="element-270"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-271">
        <FadeIn data-id="element-272">
          <h2 className="text-3xl md:text-4xl font-black text-center text-beige mb-3" data-id="element-273">
            ¿Qué incluye <span className="text-gold" data-id="element-274">Piano Fácil PRO</span>?
          </h2>
          <p className="text-center text-beige/60 mb-12 text-lg" data-id="element-275">
            8 tomos completos + 3 bonos exclusivos
          </p>
        </FadeIn>

        {/* TOMOS — combined card with two blocks */}
        <FadeIn data-id="element-276">
          <div className="bg-navy border border-gold/20 rounded-3xl p-8 md:p-10 shadow-2xl mb-6" data-id="element-277">
            <div className="flex items-center gap-2 mb-2" data-id="element-278">
              <Check className="w-6 h-6 text-gold" data-id="element-279" />
              <h3 className="text-xl font-bold text-gold" data-id="element-280">
                8 Tomos del Método Completo
              </h3>
            </div>
            <p className="text-beige/60 text-sm mb-8 ml-8" data-id="element-281">
              <span className="line-through" data-id="element-282">Total AR$ 63.920</span>
              <span className="mx-2" data-id="element-283">→</span>
              <span className="text-green-400 font-bold" data-id="element-284">
                Solo por hoy a AR$ 28.990
              </span>
            </p>

            {/* Niños block */}
            <div className="mb-8" data-id="element-285">
              <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gold/10" data-id="element-286">
                <div className="w-8 h-8 rounded-lg bg-gold/15 flex items-center justify-center" data-id="element-287">
                  <Baby className="w-4 h-4 text-gold" data-id="element-288" />
                </div>
                <h4 className="text-base md:text-lg font-bold text-beige uppercase tracking-wide" data-id="element-289">
                  Para Niños
                </h4>
              </div>
              <div className="space-y-3" data-id="element-290">
                {tomosNinos.map((t, i) => renderTomo(t, i))}
              </div>
            </div>

            {/* Adolescentes block */}
            <div data-id="element-291">
              <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gold/10" data-id="element-292">
                <div className="w-8 h-8 rounded-lg bg-gold/15 flex items-center justify-center" data-id="element-293">
                  <Users className="w-4 h-4 text-gold" data-id="element-294" />
                </div>
                <h4 className="text-base md:text-lg font-bold text-beige uppercase tracking-wide" data-id="element-295">
                  Para Adolescentes
                </h4>
              </div>
              <div className="space-y-3" data-id="element-296">
                {tomosAdolescentes.map((t, i) => renderTomo(t, i))}
              </div>
            </div>
          </div>
        </FadeIn>

        {/* BONOS */}
        <FadeIn data-id="element-297">
          <div className="bg-gold/5 border-2 border-emerald-400/40 rounded-3xl p-8 md:p-10 shadow-xl mb-6" data-id="element-298">
            <div className="flex items-center gap-2 mb-6" data-id="element-299">
              <Gift className="w-6 h-6 text-gold" data-id="element-300" />
              <h3 className="text-xl font-bold text-gold" data-id="element-301">
                3 Bonos Exclusivos
              </h3>
            </div>

            <div className="space-y-3 mb-6" data-id="element-302">
              {bonos.map((bono, index) => <FadeIn key={index} delay={index * 0.06} direction="up" data-id="element-303">
                  <div className="flex items-center justify-between gap-4 bg-navy-lighter p-4 rounded-xl border border-emerald-400/20" data-id="element-304">
                    <div className="flex items-center gap-3" data-id="element-305">
                      <div className="w-7 h-7 rounded-full bg-emerald-500 flex items-center justify-center flex-shrink-0" data-id="element-306">
                        <Gift className="w-4 h-4 text-white" strokeWidth={2.5} data-id="element-307" />
                      </div>
                      <span className="text-base md:text-lg font-medium text-beige" data-id="element-308">
                        {bono.name}
                      </span>
                    </div>
                    <span className="text-sm text-beige/40 line-through flex-shrink-0" data-id="element-309">
                      AR$ {bono.value}
                    </span>
                  </div>
                </FadeIn>)}
            </div>

            <div className="bg-emerald-500/15 border border-emerald-400/40 rounded-xl p-3 text-center" data-id="element-310">
              <span className="text-emerald-300 font-bold text-lg" data-id="element-311">
                🎁 GRATIS POR HOY
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}